/**
 * How a list moves through its results: numbered pages, or rows appended as
 * the bottom comes into view.
 */
export type PagingMode = 'pages' | 'scroll';

const storageKey = (listKey: string) => `list-mode:${listKey}`;

/**
 * The mode this viewer last picked for a list, else scroll — the default. A
 * preference, not state: storage can be empty or throw (private windows,
 * blocked site data), and the list then simply starts in scroll.
 */
export function readPagingMode(listKey: string): PagingMode {
	try {
		return localStorage.getItem(storageKey(listKey)) === 'pages' ? 'pages' : 'scroll';
	} catch {
		return 'scroll';
	}
}

export function writePagingMode(listKey: string, mode: PagingMode) {
	try {
		localStorage.setItem(storageKey(listKey), mode);
	} catch {
		// Not remembered next visit; the URL still carries it for this one.
	}
}
